import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { TerraceTemplateVM, IDefaultTerraceTemplateReachRow } from './TerraceTemplateVM';
import { useHistory, useParams } from 'react-router-dom';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import './TerraceTemplate.scss';
import { Input } from 'cd-eft/components/common/Input';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import { Table, CustomInput, Row, Col, Container } from 'reactstrap';
import { ButtonBlock } from '../../common/ButtonBlock/ButtonBlock';
import { ReachTemplateContainer } from '../../common/ReachTemplate/ReachTemplate';
import TerracdTemplateImage from '../../../../assets/images/TerraceTemplateImage.jpg';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import stores from 'cd-eft/models/Stores';

const TerraceTemplateComponent = () => {
  const history = useHistory();
  const { terraceId }: any = useParams();
  const { terraceDesignStore} = stores.AppStore;

  const vmRef = useRef<TerraceTemplateVM | null>(null);

  if(!vmRef.current){
    vmRef.current  = new TerraceTemplateVM(history);
  }
  
  const vm =vmRef.current;

  useEffect(() => {
    terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId = +terraceId;
    vm.init();
    terraceDesignStore.terraceHistory  = history
    // On initial load of Template, get possible existing values
    
  }, []);

  return (
    <Container>
      <Row>
        <Col xs="12">
          <Accordion
            className={'accordion-wrapper'}
            headers={['Orientation']}
            waterwayWizardStatus={1}
            onClickInformationToggle={vm.onClickInformationToggle}
            light={true}
            iconPathQ={true}
          >
            <div className="orientaion-container ">
              <h2 className="bold-headers">Uphill Direction</h2>
              <span className=""> When looking along the Alignment</span>
              <Col xs={12}>
                <Row>
                  <RadioGroup
                    labelId="uphill-direction-radio"
                    items={[
                      {
                        id: 'uphillDirectionLeft',
                        name: 'uphillDirectionLeft',
                        label: 'Left',
                        className: 'usa-radio__input--tile',
                        checked: vm.leftRadioControl,
                        onChange: vm.handleInputChange,
                      },
                      {
                        id: 'uphillDirectionRight',
                        name: 'uphillDirectionRight',
                        label: 'Right',
                        className: 'usa-radio__input--tile',
                        checked: vm.rightRadioControl,
                        onChange: vm.handleInputChange,
                      },
                    ]}
                  />
                  <img className="img-container" src={TerracdTemplateImage} alt="Terrace Template Image" />
                </Row>
                <Row className="margin-top">
                  <Col xs={6}>
                    <ComboBox
                      NoInitialBlankOption={true}
                      idAndName="flag-line-location"
                      label="Flag Line Location"
                      aria-label="Flag Line Location"
                      valid={true}
                      value={vm.orientationFormData.flagLineLocation}
                      onChange={(e) => vm.handleInputChange(e)}
                      options={vm.flagLineLocationOptions}
                      errorMsg={''}
                      required={true}
                      // className={vm.TerraceTemplateErrorClass('flagLineLocation')}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    <Input
                      label="Offset from Alignment (ft)"
                      idAndName="offset-from-alignment"
                      valid={true}
                      value={vm.orientationFormData.offsetFromAlignment}
                      type="number"
                      onChange={vm.handleInputChange}
                      step={0.01}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className={vm.formValidation.formErrors.offsetFromAlignment}
                      onKeyDown={() => {}}
                    />
                  </Col>
                </Row>
              </Col>
            </div>
          </Accordion>
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          <Accordion
            className={'accordion-wrapper'}
            headers={[`Cross Section Controls: ${vm.templateName}`]}
            waterwayWizardStatus={1}
            onClickInformationToggle={vm.onClickInformationToggle}
            light={true}
            iconPathQ={true}
          >
            <div className="cross-section-container">
              <ReachTemplateContainer
                reachTemplateForm={vm.reachTemplateForm}
                formValidation={vm.formValidation}
                handleInputChange={vm.handleInputChange}
                handleOnBlur={vm.handleOnBlur}
              />
              <div className="template-button">
                <button onClick= {() => vm.toggleSelectTemplate()} className="usa-button">Select Template</button>
              </div>
              {vm.displayTemplateTable ?
              <>
              <div className='template-table-title row'>
                <h2 className="bold-headers">Choose a cross-section template from the list below</h2>
              </div>

              <div className='template-table-scrollable-wrapper'>
                <Table className="set-table usa-table--borderless">
                  <thead >
                    <tr>
                      <th>
                        Select
                      </th>
                      <th>
                        Name
                      </th>
                      <th>
                        Description
                      </th>
                      <th>
                        Cut Slope
                      </th>
                      <th>
                        Front Slope
                      </th>
                      <th>
                        Back Slope
                      </th>
                      <th>
                        Bottom Width
                      </th>
                      <th>
                        Front Height
                      </th>
                      <th>
                        Top Width
                      </th>
                    </tr>
                  </thead>
                  <tbody className="table-body">
                    {vm.terraceTemplateReachesObject.map((item: IDefaultTerraceTemplateReachRow, index: number) => (
                      <tr key={'key-Terrace-Template-Table-' + index}>
                        <td>
                          <div className="usa-radio" key={"group" + index}>
                            <input
                              className={'usa-radio__input ' + ''}
                              id={item.terraceChannelTemplateID.toString()}
                              key={item.terraceChannelTemplateID + index}
                              data-testid={'the-RadioGroup-' + index}
                              type="radio"
                              name={"parseThis " + item.terraceChannelTemplateID}
                              checked={vm.defaultTemplateRadioControl === item.terraceChannelTemplateID}
                              onChange={vm.handleRadioInputChange}
                              disabled={false}
                            />
                            <label className="usa-radio__label" htmlFor={item.terraceChannelTemplateID.toString()} key={"label" + item.terraceChannelTemplateID + index}>
                              <span className='hide-this-label'>{item.templateName}</span>
                            </label>
                          </div>
                        </td>
                        <td>
                          {item.templateName}
                        </td>
                        <td className="Template-Description-Column">
                          {item.comments}
                        </td>
                        <td className='no-tooltip-column'>
                          {item.cutSlope}&nbsp;
                          {((item.cutSlopeMode === 1) ? "ft/ft" : "ft")}
                        </td>
                        <td className='no-tooltip-column'>
                          {item.frontSlope}&nbsp;
                          {((item.frontSlopeMode === 1) ? "ft/ft" : "ft")}
                        </td>
                        <td className='no-tooltip-column'>
                          {item.backSlope}&nbsp;
                          {((item.backSlopeMode === 1) ? "ft/ft" : "ft")}
                        </td>
                        <td className='no-tooltip-column'>
                          {item.bottomWidth + ' ft'}
                        </td>
                        <td className='no-tooltip-column'>
                          {item.frontHeight + ' ft'}
                        </td>
                        <td className='no-tooltip-column'>
                          {item.topWidth + ' ft'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div> 
              </>
              : null}
            </div>
          </Accordion>
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          <Accordion
            className={'terrace-templete accordion-wrapper'}
            headers={['Shape Controls']}
            waterwayWizardStatus={1}
            onClickInformationToggle={vm.onClickInformationToggle}
            light={true}
            iconPathQ={true}
          >
            <div className="shape-controls-container">
              <Row>
                <Col xs={6}>
                  <Col>
                    <ComboBox
                      NoInitialBlankOption={true}
                      label="Overfill Mode"
                      idAndName="overfill-mode"
                      valid={true}
                      value={vm.shapeControls.overfillMode}
                      onChange={vm.handleInputChange}
                      options={vm.shapeOverallModeOptions}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      // className={vm.TerraceTemplateErrorClass('overfillMode')}
                    />
                  </Col>
                  <Col>
                    <Input
                      label="Overfill Amount"
                      idAndName="overfill-amount"
                      valid={true}
                      value={vm.shapeControls.overfillAmount}
                      disabled={vm.shapeControls.overfillAmountDisabled}
                      type="number"
                      step={0.01}
                      onChange={vm.handleInputChange}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className={vm.formValidation.formErrors.overfillAmount}
                      wrapperClassName={vm.shapeControls.overfillAmountDisabled? 'grey-label': ''}
                      min={0}
                    />
                  </Col>
                  <Col>
                    <ComboBox
                      NoInitialBlankOption={true}
                      label="Freeboard Mode"
                      idAndName="freeboard-mode"
                      valid={true}
                      value={vm.shapeControls.freeboardMode}
                      onChange={vm.handleInputChange}
                      options={vm.shapeFreeboardModeOptions}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      // className={vm.TerraceTemplateErrorClass('freeboardMode')}
                    />
                  </Col>
                  <Col>
                    <Input
                      label="Freeboard (ft)"
                      idAndName="freeboard"
                      valid={true}
                      value={vm.shapeControls.freeboard}
                      disabled={vm.shapeControls.freeboardDisabled}
                      type="number"
                      onChange={vm.handleInputChange}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className={vm.formValidation.formErrors.freeboard}
                      step={0.01}
                      min={0}
                      wrapperClassName={vm.shapeControls.freeboardDisabled? 'grey-label': ''}
                    />
                  </Col>
                  <Col>
                    <h2 className="bold-headers-embankment">Embankment Start Slope</h2>
                  </Col>
                  <Col>
                    <Row className='row-margin'>

                      <label
                        className={`${vm.shapeControls.gradeChannelStart ? 'select-label' : 'select-label-unchecked'}`}
                        htmlFor="grade-channel-start"
                      >
                        Grade Channel/Bank at Start
                      </label>
                      <CustomInput
                        id="grade-channel-start"
                        name="grade-channel-start"
                        type="switch"
                        className={`checkbox-input-switch${vm.shapeControls.gradeChannelStart ? ' selected' : ''}`}
                        bsSize="lg"
                        checked={vm.shapeControls.gradeChannelStart}
                        onChange={vm.handleInputChange}
                      />
                    </Row>
                  </Col>
                  <Col>
                    <ComboBox
                      NoInitialBlankOption={true}
                      label="Mode"
                      idAndName="start-mode"
                      valid={true}
                      disabled={!vm.shapeControls.gradeChannelStart}
                      value={vm.shapeControls.startMode}
                      onChange={vm.handleInputChange}
                      options={vm.shapeBackStartModeOptions}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      // className={vm.TerraceTemplateErrorClass('startMode')}
                      wrapperName={vm.shapeControls.gradeChannelStart? '':'grey-label'}
                    />
                  </Col>
                  <Col>
                    <Input
                      label={`${vm.shapeControls.startMode === 'RATIO_BASED' ? 'Value (ft/ft)' : 'Value (ft)'}`}
                      idAndName="start-value"
                      valid={true}
                      disabled={!vm.shapeControls.gradeChannelStart}
                      value={vm.shapeControls.startValue}
                      readOnly={false}
                      type="number"
                      onChange={vm.handleInputChange}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className={ vm.shapeControls.gradeChannelStart? vm.formValidation.formErrors.startValue : ''}
                      wrapperClassName={vm.shapeControls.gradeChannelStart? '':'grey-label'}
                      step={0.01}
                      min={0}
                    />
                  </Col>
                  <Col>
                    <Input
                      label="Limiting Mode "
                      idAndName="limiting-mode"
                      valid={true}
                      disabled={!vm.shapeControls.gradeChannelStart}
                      value={vm.shapeControls.startMode === 'RATIO_BASED'? 'Width Based': 'Ratio Based'}
                      readOnly={true}
                      type="text"
                      onChange={vm.handleInputChange}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className='limitingSlopeMode'
                      wrapperClassName={vm.shapeControls.gradeChannelStart? '':'grey-label'}
                    />
                  </Col>
                  <Col>
                    <Input
                      label={`Limit ${vm.shapeControls.startMode === 'RATIO_BASED'? '(ft)': '(ft/ft)'}`}
                      idAndName="start-limit"
                      valid={true}
                      value={vm.shapeControls.startLimit}
                      readOnly={false}
                      disabled={!vm.shapeControls.gradeChannelStart}
                      type="number"
                      onChange={vm.handleInputChange}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className={vm.shapeControls.gradeChannelStart? vm.formValidation.formErrors.startLimit : ''}
                      wrapperClassName={vm.shapeControls.gradeChannelStart? '':'grey-label'}
                      step={0.01}
                      min={0}
                    />
                  </Col>
                </Col>
                <Col xs={6}>
                  <div className="backCut-form">
                    <Col>
                      <Row>
                        <span className="bold-headers-backcut">Back Cut</span>
                        <label
                          className={`${vm.shapeControls.backCutEnabled ? 'select-label' : 'select-label-unchecked'}`}
                          htmlFor="backCutEnabled"
                        >
                          {!vm.shapeControls.backCutEnabled ? 'Enable Back Cut' : 'Back Cut Enabled'}
                        </label>
                        <CustomInput
                          id="backCutEnabled"
                          name="backCutEnabled"
                          type="switch"
                          className={`checkbox-input-switch${vm.shapeControls.backCutEnabled ? ' selected' : ''}`}
                          bsSize="lg"
                          checked={vm.shapeControls.backCutEnabled}
                          onChange={vm.handleInputChange}
                        />
                      </Row>
                    </Col>

                    <Col>
                      <Input
                        label="Minimum Slope Width (ft)"
                        idAndName="minimum-slope-width"
                        valid={true}
                        value={vm.shapeControls.minimumSlopeWidth}
                        disabled={!vm.shapeControls.backCutEnabled}
                        type="number"
                        onChange={vm.handleInputChange}
                        step={0.01}
                        onBlur={(e)=>vm.handleOnBlur(e)}
                        className={!vm.shapeControls.backCutEnabled? '' : vm.formValidation.formErrors.minimumSlopeWidth}
                        onKeyDown={() => {}}
                        wrapperClassName={vm.shapeControls.backCutEnabled ? '':'grey-label'}
                        min={0}
                        readOnly={false}
                      />
                    </Col>
                    <Col>
                      <Input
                        label="Back Cut-Slope Grade (%)"
                        idAndName="back-cut-slope-grade"
                        valid={true}
                        value={vm.shapeControls.backCutSlopeGrade}
                        disabled={!vm.shapeControls.backCutEnabled}
                        type="number"
                        onChange={vm.handleInputChange}
                        step={0.01}
                        onBlur={(e)=>vm.handleOnBlur(e)}
                        className={!vm.shapeControls.backCutEnabled ? '' : vm.formValidation.formErrors.backCutSlopeGrade}
                        wrapperClassName={vm.shapeControls.backCutEnabled ? '':'grey-label'}
                        onKeyDown={() => {}}
                        min={0}
                        readOnly={false}
                      />
                    </Col>
                  </div>
                  <Col>
                    <h2 className="bold-headers-embankment">Embankment End Slope</h2>
                  </Col>
                  <Col>
                    <Row className='row-margin'>
                      <label
                        className={`${vm.shapeControls.gradeChannelEnd ? 'select-label' : 'select-label-unchecked'}`}
                        htmlFor="grade-channel-end"
                      >
                        Grade Channel/Bank at End
                      </label>
                      <CustomInput
                        id="grade-channel-end"
                        name="grade-channel-end"
                        type="switch"
                        className={`checkbox-input-switch${vm.shapeControls.gradeChannelEnd ? ' selected' : ''}`}
                        bsSize="lg"
                        checked={vm.shapeControls.gradeChannelEnd}
                        onChange={vm.handleInputChange}
                      />
                    </Row>
                  </Col>
                  <Col>
                    <ComboBox
                      NoInitialBlankOption={true}
                      label="Mode"
                      idAndName="end-mode"
                      valid={true}
                      value={vm.shapeControls.endMode}
                      onChange={vm.handleInputChange}
                      options={vm.shapeBackEndModeOptions}
                      disabled={!vm.shapeControls.gradeChannelEnd }
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      // className={vm.TerraceTemplateErrorClass('endMode')}
                      wrapperName={vm.shapeControls.gradeChannelEnd? '':'grey-label'}
                    />
                  </Col>
                  <Col>
                    <Input
                      label={`${vm.shapeControls.endMode === 'RATIO_BASED' ? 'Value (ft/ft)' : 'Value (ft)'}`}
                      idAndName="end-value"
                      valid={true}
                      value={vm.shapeControls.endValue}
                      readOnly={false}
                      disabled={!vm.shapeControls.gradeChannelEnd }
                      type="number"
                      onChange={vm.handleInputChange}
                      step={0.01}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className={!vm.shapeControls.gradeChannelEnd ? '' : vm.formValidation.formErrors.endValue }
                      wrapperClassName={vm.shapeControls.gradeChannelEnd? '':'grey-label'}
                      onKeyDown={() => {}}
                      min={0}
                    />
                  </Col>
                  <Col>
                    <Input
                      label="Limiting Mode "
                      idAndName="limiting-mode-end"
                      valid={true}
                      value={vm.shapeControls.endMode === 'RATIO_BASED'? 'Width Based': 'Ratio Based'}
                      readOnly={true}
                      disabled={!vm.shapeControls.gradeChannelEnd }
                      type="text"
                      onChange={vm.handleInputChange}
                      errorMsg={''}
                      required={true}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className='limitingSlopeMode '
                      wrapperClassName={vm.shapeControls.gradeChannelEnd? '':'grey-label'}
                    />
                  </Col>
                  <Col>
                    <Input
                      label={`Limit ${vm.shapeControls.endMode === 'RATIO_BASED'? '(ft)': '(ft/ft)'}`}
                      idAndName="end-limit"
                      valid={true}
                      value={vm.shapeControls.endLimit}
                      disabled={!vm.shapeControls.gradeChannelEnd }
                      readOnly={false}
                      type="number"
                      onChange={vm.handleInputChange}
                      step={0.01}
                      onBlur={(e)=>vm.handleOnBlur(e)}
                      className={!vm.shapeControls.gradeChannelEnd? '' : vm.formValidation.formErrors.endLimit}
                      wrapperClassName={vm.shapeControls.gradeChannelEnd? '':'grey-label'}
                      onKeyDown={() => {}}
                      min={0}
                    />
                  </Col>
                </Col>
              </Row>
            </div>
          </Accordion>
        </Col>
      </Row>
      <Row className="template-buttons-block">
        <Col>
          <hr />
          <ButtonBlock buttons={[
              { title: 'Close', disabled: false, onClick:terraceDesignStore.handlecloseAction, className: 'usa-button--outline' },
              { title: 'Save', disabled: vm.disableSaveButton, onClick: () => vm.showWarningOnSave('save')},
              { title: 'Save & Proceed', disabled: vm.disableSaveAndProceedButton, onClick:  () => vm.showWarningOnSave('saveProceed')},
            ]} />
        </Col>
      </Row>
      {vm.isLoading && <Loader message={''} />}
    </Container>
  );
};

export const TerraceTemplate = observer(TerraceTemplateComponent);
